import { takeEvery, put, call } from 'redux-saga/effects'

import api from 'api'
import {
    setIsFetching,
    sendHelpSupportForm,
    setSuccessSendFormData,
} from 'redux/reducers/profile'
import { showAlert } from 'redux/reducers/notification'


function* sendHelpSupportFormSagaWorker({ payload }) {
    try {
        yield put(setIsFetching(true))
        const res= yield call([api.helpSupport, 'sendHelpSupportForm'], payload)
        if (res.status === 200) {
            yield put(setSuccessSendFormData({ isShow: true }))
        }
    } catch (error) {
        yield put(
            showAlert({
                severity: 'error',
                message: error?.message,
                alertTitle: 'Something went wrong',
            })
        )
    } finally {
        yield put(setIsFetching(false))
    }
}

export default function* helpSupportSagaWatcher() {
    yield takeEvery(sendHelpSupportForm.type, sendHelpSupportFormSagaWorker)
}
